import { types } from "./actionTypes";

const CombinedPlanReducer = (state, action) => {
  const payload = action.data;

  switch (action.type) {
    case types.LOADING_COMBINED_PLAN:
      return {
        ...state,
        state: types.LOADING_COMBINED_PLAN,
      };
    case types.COMBINED_PLAN_LOAD_OK:
      return {
        ...state,
        Code: 200,
        state: types.COMBINED_PLAN_LOAD_OK,
        data: payload,
      };
    case types.COMBINED_PLAN_LOAD_FAILED:
      return {
        ...state,
        Code: payload.Code,
        state: types.COMBINED_PLAN_LOAD_FAILED,
      };
    case types.COMBINED_PLAN_RESET:
      return {
        ...state,
        state: "INITIAL_STATE",
        data: null,
        saveState: undefined,
      };

    // ── Save learning area guardian text ─────────────────────────────────
    case types.SAVING_COMBINED_PLAN_LEARNING_AREA:
      return { ...state, saveState: types.SAVING_COMBINED_PLAN_LEARNING_AREA };

    case types.COMBINED_PLAN_LEARNING_AREA_SAVED_OK: {
      // payload: { areaIndex (=SortOrder), areaListIndex, text, field } OR { questionId, areaListIndex, text, field }
      const { areaIndex, areaListIndex, questionId, text, field } = payload;
      if (!state.data || !state.data.LearningAreas)
        return {
          ...state,
          saveState: types.COMBINED_PLAN_LEARNING_AREA_SAVED_OK,
        };
      const fieldKey = field === "child" ? "Child" : "Parent";
      const savedKey = field === "child" ? "ChildSaved" : "ParentSaved";
      const now = new Date();
      const savedTimestamp =
        now.toLocaleDateString("fi-FI", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }) +
        " " +
        now.toLocaleTimeString("fi-FI", { hour: "2-digit", minute: "2-digit" });
      const updatedAreas = state.data.LearningAreas.map((area, index) => {
        if (questionId) {
          return area.QuestionId === questionId
            ? { ...area, [fieldKey]: text, [savedKey]: savedTimestamp }
            : area;
        }
        if (areaListIndex !== undefined && areaListIndex !== null) {
          return index === areaListIndex
            ? { ...area, [fieldKey]: text, [savedKey]: savedTimestamp }
            : area;
        }
        return area.SortOrder === areaIndex
          ? { ...area, [fieldKey]: text, [savedKey]: savedTimestamp }
          : area;
      });
      return {
        ...state,
        saveState: types.COMBINED_PLAN_LEARNING_AREA_SAVED_OK,
        data: { ...state.data, LearningAreas: updatedAreas },
      };
    }

    case types.COMBINED_PLAN_LEARNING_AREA_SAVED_FAILED:
      return {
        ...state,
        saveState: types.COMBINED_PLAN_LEARNING_AREA_SAVED_FAILED,
        saveCode: payload?.Code,
      };

    // ── Save spring evaluation guardian text ─────────────────────────────
    case types.SAVING_COMBINED_PLAN_SPRING_TEXT:
      return { ...state, saveState: types.SAVING_COMBINED_PLAN_SPRING_TEXT };

    case types.COMBINED_PLAN_SPRING_TEXT_SAVED_OK: {
      // payload: { text, subSectionLevel1, subSectionLevel2 }
      // subSectionLevel2 == 0 means the IndependentSection (SubSectionLevel2 = null in DB)
      const { text, subSectionLevel1, subSectionLevel2 } = payload;
      const isIndependent = subSectionLevel2 === 0;
      const springNow = new Date();
      const springSavedTimestamp =
        springNow.toLocaleDateString("fi-FI", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }) +
        " " +
        springNow.toLocaleTimeString("fi-FI", {
          hour: "2-digit",
          minute: "2-digit",
        });

      if (isIndependent) {
        // Update IndependentSection.Text
        if (!state.data?.SpringEvaluation?.IndependentSection) {
          return {
            ...state,
            saveState: types.COMBINED_PLAN_SPRING_TEXT_SAVED_OK,
          };
        }
        return {
          ...state,
          saveState: types.COMBINED_PLAN_SPRING_TEXT_SAVED_OK,
          data: {
            ...state.data,
            SpringEvaluation: {
              ...state.data.SpringEvaluation,
              IndependentSection: {
                ...state.data.SpringEvaluation.IndependentSection,
                Text: text,
                TextSaved: springSavedTimestamp,
              },
            },
          },
        };
      }

      // Update matching section in TeacherSummarySection by SubSectionLevel2
      if (!state.data?.SpringEvaluation?.TeacherSummarySection?.Sections) {
        return {
          ...state,
          saveState: types.COMBINED_PLAN_SPRING_TEXT_SAVED_OK,
        };
      }
      const sections =
        state.data.SpringEvaluation.TeacherSummarySection.Sections;
      const updatedSections = sections.map((s) =>
        s.SubSectionLevel2 === subSectionLevel2
          ? { ...s, Text: text, TextSaved: springSavedTimestamp }
          : s,
      );
      return {
        ...state,
        saveState: types.COMBINED_PLAN_SPRING_TEXT_SAVED_OK,
        data: {
          ...state.data,
          SpringEvaluation: {
            ...state.data.SpringEvaluation,
            TeacherSummarySection: {
              ...state.data.SpringEvaluation.TeacherSummarySection,
              Sections: updatedSections,
            },
          },
        },
      };
    }

    case types.COMBINED_PLAN_SPRING_TEXT_SAVED_FAILED:
      return {
        ...state,
        saveState: types.COMBINED_PLAN_SPRING_TEXT_SAVED_FAILED,
        saveCode: payload?.Code,
      };

    // ── Child self-assessment (smiley evaluation) ────────────────────────
    case types.LOADING_COMBINED_PLAN_SELF_ASSESSMENT:
      return {
        ...state,
        selfAssessmentState: types.LOADING_COMBINED_PLAN_SELF_ASSESSMENT,
      };

    case types.COMBINED_PLAN_SELF_ASSESSMENT_LOAD_OK:
      return {
        ...state,
        selfAssessment: payload,
        selfAssessmentCode: 200,
        selfAssessmentState: types.COMBINED_PLAN_SELF_ASSESSMENT_LOAD_OK,
      };

    case types.COMBINED_PLAN_SELF_ASSESSMENT_LOAD_FAILED:
      return {
        ...state,
        selfAssessmentCode: payload?.Code,
        selfAssessmentState: types.COMBINED_PLAN_SELF_ASSESSMENT_LOAD_FAILED,
      };

    case types.SAVING_COMBINED_PLAN_SELF_ASSESSMENT:
      return {
        ...state,
        selfAssessmentSaveState: types.SAVING_COMBINED_PLAN_SELF_ASSESSMENT,
      };

    case types.COMBINED_PLAN_SELF_ASSESSMENT_SAVED_OK:
      return {
        ...state,
        selfAssessmentSaveState: types.COMBINED_PLAN_SELF_ASSESSMENT_SAVED_OK,
      };

    case types.COMBINED_PLAN_SELF_ASSESSMENT_SAVED_FAILED:
      return {
        ...state,
        selfAssessmentSaveState:
          types.COMBINED_PLAN_SELF_ASSESSMENT_SAVED_FAILED,
        selfAssessmentCode: payload?.Code,
      };

    case types.COMBINED_PLAN_SELF_ASSESSMENT_HANDLED:
      return {
        ...state,
        selfAssessmentSaveState: undefined,
      };

    // ── Save approval ────────────────────────────────────────────────────
    case types.SAVING_COMBINED_PLAN_APPROVAL:
      return {
        ...state,
        approvalSaveState: types.SAVING_COMBINED_PLAN_APPROVAL,
      };

    case types.COMBINED_PLAN_APPROVAL_SAVED_OK: {
      // payload: { personId, documentId, info, type }
      const { personId, documentId, info } = payload;
      if (!state.data || !state.data.SupportTiers) {
        return {
          ...state,
          approvalSaveState: types.COMBINED_PLAN_APPROVAL_SAVED_OK,
        };
      }
      const d = new Date();
      const now =
        d.getDate().toString().padStart(2, "0") +
        "." +
        (d.getMonth() + 1).toString().padStart(2, "0") +
        "." +
        d.getFullYear();

      const newApproval = {
        PersonId: personId,
        DocumentId: documentId,
        Info: info,
        Saved: now,
      };

      const updateTierApproval = (tier) => {
        if (!tier || tier.DecisionPersonAttachmentId !== documentId)
          return tier;
        const updated = { ...tier };
        if (
          tier.Guardian1Approval?.PersonId === personId ||
          (!tier.Guardian1Approval && state.data.Guardian1PersonId === personId)
        ) {
          updated.Guardian1Approval = newApproval;
        }
        if (
          tier.Guardian2Approval?.PersonId === personId ||
          (!tier.Guardian2Approval && state.data.Guardian2PersonId === personId)
        ) {
          updated.Guardian2Approval = newApproval;
        }
        return updated;
      };

      return {
        ...state,
        approvalSaveState: types.COMBINED_PLAN_APPROVAL_SAVED_OK,
        data: {
          ...state.data,
          SupportTiers: {
            ...state.data.SupportTiers,
            EnhancedSupport: updateTierApproval(
              state.data.SupportTiers.EnhancedSupport,
            ),
            SpecialSupport: updateTierApproval(
              state.data.SupportTiers.SpecialSupport,
            ),
          },
        },
      };
    }

    case types.COMBINED_PLAN_APPROVAL_SAVED_FAILED:
      return {
        ...state,
        approvalSaveState: types.COMBINED_PLAN_APPROVAL_SAVED_FAILED,
        approvalSaveCode: payload?.Code,
      };

    case types.COMBINED_PLAN_APPROVAL_HANDLED:
      return { ...state, approvalSaveState: undefined };

    default:
      return state;
  }
};

export default CombinedPlanReducer;
